import {
  differenceInDays,
  eachMonthOfInterval,
  endOfMonth,
  startOfMonth,
} from 'date-fns';

export function getMonthWithMostDays(
  startDate: Date,
  endDate: Date,
): { month: number; year: number } {
  const monthsInRange = eachMonthOfInterval({ start: startDate, end: endDate });

  // If start and end date are in the same month, return that month
  if (monthsInRange.length === 1) {
    return {
      month: monthsInRange[0].getMonth() + 1,
      year: monthsInRange[0].getFullYear(),
    };
  }

  // If there are only two months, return the one with the most days in it
  if (monthsInRange.length === 2) {
    const daysInFirstMonth = Math.abs(
      differenceInDays(startDate, endOfMonth(startDate)),
    );

    const daysInSecondMonth =
      Math.abs(differenceInDays(endDate, startOfMonth(endDate))) + 1;

    // If the first month has more days, return that month
    if (daysInFirstMonth > daysInSecondMonth) {
      return {
        month: startDate.getMonth() + 1,
        year: startDate.getFullYear(),
      };
    } else {
      // If the second month has more days or they have the same number of days, return the second month
      return {
        month: endDate.getMonth() + 1,
        year: endDate.getFullYear(),
      };
    }
  }

  // If there are more than two months, return the last complete month
  let monthWithMostDays: { month: number; year: number } = {
    month: 0,
    year: 0,
  };

  // If the end date is the last day of the last month, return that month
  if (endDate.getDate() === endOfMonth(endDate).getDate()) {
    monthWithMostDays = {
      month: endDate.getMonth() + 1,
      year: endDate.getFullYear(),
    };
  } else {
    // If the end date is not the last day of the last month, return the last complete month
    monthWithMostDays = {
      month: monthsInRange[monthsInRange.length - 2].getMonth() + 1,
      year: monthsInRange[monthsInRange.length - 2].getFullYear(),
    };
  }

  return monthWithMostDays;
}
